import { z } from "zod";
import type { infer as zInfer } from "zod";
import { baseAutomation } from "@/hooks/firestore/models/baseAutomation";
import { timestamp } from "@/hooks/firestore/models/timestamp";

export const currentAutomationProgression = baseAutomation.extend({
  progressionId: z.string(),
  status: z.string().optional(),
  expiresAt: timestamp.optional(),
  name: z.string(),
  entities: z.array(
    z.object({
      entityId: z.string(),
      info: z.string(),
      status: z.string(),
      type: z.string(),
      rewardInfo: z
        .object({
          fiatCashRewarded: z.number(),
          promoCashRewarded: z.number(),
          projectedFiatCashReward: z.number().optional(),
          projectedPromoCashReward: z.number().optional(),
        })
        .nullish(),
    }),
  ),
});

export type CurrentAutomationProgression = zInfer<
  typeof currentAutomationProgression
>;
